<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Claim No.</v-subheader>
        <span class="queryValue">{{ this.claimHeaderForm.clmNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Status / Status Date </v-subheader>
        <span class="queryValue"
          >{{ this.claimHeaderForm.clmStatDesc }} / {{ formatDate(this.claimHeaderForm.statDate) }}</span
        >
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Loss Date, Time</v-subheader>
        <span class="queryValue">{{ formatDisplayDateTime4(claimHeaderForm.lossDate) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Notification Date, Time</v-subheader>
        <span class="queryValue">{{ formatDisplayDateTime4(claimHeaderForm.notDate) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Branch / Country</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.branch }} - {{ claimHeaderForm.branchDesc }} / {{ claimHeaderForm.ctyDesc }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Direct / RI Inwards</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.dri }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Policy Type</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.polType }} - {{ claimHeaderForm.polTypeDesc }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Business Class</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.busClsDesc }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Policy No. </v-subheader>
        <span class="queryValue"
          >{{ this.claimHeaderForm.polNo }} / {{ padString(this.commonInfo.renCnt, 2) }} / {{ padString(this.commonInfo.endtCnt, 3) }}</span
        >
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Risk Group / Risk No.</v-subheader>
        <span class="queryValue">{{ padString(this.commonInfo.riskGrpNo, 2) }} / {{ padString(this.claimHeaderForm.riskNo, 5) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">UW Year</v-subheader>
        <span class="queryValue">{{ this.commonInfo.uwYr }}</span>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Commencement Date </v-subheader>
        <span class="queryValue">{{ formatDate(this.claimHeaderForm.comDate) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Expiry Date </v-subheader>
        <span class="queryValue">{{ formatDate(this.claimHeaderForm.expDate) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Insured </v-subheader>
        <span class="queryValue">{{ getInsuredName() }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime4 } from '@/utils/date'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import MessageMixin from '@/mixins/message'
import clone from 'clone'

export default {
  data() {
    return {
      claimHeaderForm: {},
      hideVesName: undefined
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    resCurrList() {
      return this.$store.state.claims.claimParams.resCurrList
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime4(dateTime) {
      return formatDisplayDateTime4(dateTime)
    },
    padString(no, length) {
      if (no) {
        return no.toString().padStart(length, '0')
      } else {
        return no
      }
    },
    async doInit() {
      this.claimHeaderForm = clone(this.commonInfo)
    },
    getInsuredName() {
      var result = ''
      if (this.claimHeaderForm.insdRefNo) {
        result = result + this.claimHeaderForm.insdRefNo + ' - '
      }
      if (this.claimHeaderForm.insdName1) {
        result = result + this.claimHeaderForm.insdName1 + ' '
      }
      if (this.claimHeaderForm.insdName2) {
        result = result + this.claimHeaderForm.insdName2 + ' '
      }
      if (this.claimHeaderForm.insdName3) {
        result = result + this.claimHeaderForm.insdName3 + ' '
      }
      return result
    }
  },
  async mounted() {
    this.doInit()
    if (this.claimHeaderForm.dept === 'M' || this.claimHeaderForm.dept === 'C') {
      this.hideVesName = false
    } else {
      this.hideVesName = true
    }
  },
  mixins: [MessageMixin, ClaimCommonMixin]
}
</script>
